import { Image } from '@udemy/react-core-components';
import classNames from 'classnames';
import React from 'react';
import styles from "./card-media-image.module.css";
/** Props for `CardMediaImage` component */

/**
 * ### CardMediaImage component
 *
 * Renders an image within a container for cards.
 *
 * Adjust the media container's layout with the `layout` prop.
 **/
export const CardMediaImage = _ref => {
  let {
    alt = '',
    src,
    src2x,
    srcSet,
    sizes,
    layout
  } = _ref;
  let srcSetAttribute = {};

  if (srcSet) {
    srcSetAttribute = {
      srcSet
    };
  } else if (src2x) {
    srcSetAttribute = {
      srcSet: `${src} 1x, ${src2x} 2x`
    };
  }

  return /*#__PURE__*/React.createElement(Image, Object.assign({
    alt: alt,
    className: classNames(styles.image, styles[layout]),
    src: src,
    sizes: sizes
  }, srcSetAttribute));
};
//# sourceMappingURL=card-media-image.react-component.js.map